var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('h2',{staticClass:"ViewHeading"},[_vm._v("Service")]),_c('b-card',[_c('ClientService')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }